<template>
  <div class="containers">
    <div v-if="goArea == true" class="area-list">
      <CAlert
          v-if="success == true"
          :show.sync="currentAlertCounter"
          closeButton
          style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
      >
        {{ alertMess }}
      </CAlert>
      <CAlert
          v-else
          :show.sync="currentAlertCounter"
          closeButton
          style="background-color:red;border-radius:0;text-align:center;color:white"
      >
        {{ alertMess }}
      </CAlert>
      <div class="search-area">
        <CRow>
          <CCol sm="5">
            <input type="text" v-model="searchUnitName" placeholder="Nama Unit" class="form-control"/>
          </CCol>
          <CCol sm="5">
            <input type="text" v-model="searchParentUnitName" placeholder="Nama Parent Unit" class="form-control"/>
          </CCol>
          <CCol sm="2">
            <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
          </CCol>
        </CRow>
      </div>
      <div class="sticky1">
        <CRow>
          <CCol sm="4"></CCol>
          <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon
                            :icon="{prefix: 'fas', iconName: 'chevron-left'}"/></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon
                            :icon="{prefix: 'fas', iconName: 'chevron-left'}"/></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon
                            :icon="{prefix: 'fas', iconName: 'chevron-right'}"/></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon
                            :icon="{prefix: 'fas', iconName: 'chevron-right'}"/></CButton>
                    </span>
            <input @change="validatePage(page)" v-if="totalPage != 1"
                   style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page"
                   class="text-center rounded p-1" type="text">
            <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right"
                   v-model="page" class="text-center rounded p-1" type="text">
            <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span
                style="color:rgba(16, 16, 16, 1)">{{ firstPage }} - {{ lastPage }}</span> of {{ totalRow }}</span>
            <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
            <img class="mr-5 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:right;cursor:pointer"
                 :src="downloadIcon" title="export to excel" width="20px" height="20px"/>
            <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px"
                 style="float:right;cursor:pointer"/>
          </CCol>
          <CCol sm="2">
            <CButton @click="moving()" type="button" class="btn btn-add">Tambah</CButton>
          </CCol>
        </CRow>
      </div>
      <Tables @sort="sorting" @edit="editData" @delete="deleteData" :data="datas" :th="dataTh" :td="dataTd"
              :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
      <CModal
          size="sm"
          :centered="true"
          title="Info Delete"
          color="danger"
          :show.sync="deleteModal"
      >
        <p>Apakah anda yakin ingin menghapus {{ unitName }}?</p>
        <CRow>
          <CCol sm="6">
            <CButton @click="cancelDelete()" class="btn btn-secondary w-100 text-center btn-cancel">Batal</CButton>
          </CCol>
          <CCol sm="6">
            <CButton @click="onDelete()" class="btn btn-danger w-100 text-center btn-delete">Ya, Hapus</CButton>
          </CCol>
        </CRow>
        <template #footer-wrapper><span></span></template>
      </CModal>
      <CRow class="area-back">
        <CCol sm="12">
          <img class="mt-2 mb-2" @click="moveArea()" :src="backIcon" width="20px" height="20px"
               style="float:left;cursor:pointer"/>
        </CCol>
      </CRow>
      <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
      <CRow class="area-input">
        <CCol sm="12">
          <CRow>
            <CCol sm="6">
              <label>Nama Unit</label>
              <input
                  class="form-control"
                  v-model.trim="$v.unitName.$model"
                  :class="{ 'is-invalid':$v.unitName.$error, 'is-valid': !$v.unitName.$invalid }"
                  placeholder="Nama Unit"
                  type="text"
              />
            </CCol>
            <CCol xs="12" md="6">
              <label>Pegawai Atasan</label>
              <div class="autocomplete">
                <input type="text"
                       class="form-control"
                       @click="toggleVisiblePegawai()"
                       @blur="toggleCloseVisiblePegawai()"
                       v-model="queryPegawai"
                       v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                       @keydown.up="upPegawai"
                       @keydown.down="downPegawai"
                       @keydown.enter="selectItemPegawai"
                       placeholder="Pilih Pegawai"
                >
                <div class="popovers" v-show="visiblePegawai">
                  <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in matchesPegawai"
                          :key="index"
                          :class="{ 'selected': (selectedPegawai == index)}"
                          @click="itemClickedPegawai(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                    Data Tidak Ditemukan
                  </div>
                  <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                    Start Typing...
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="6">
              <label>Nama Parent Unit (Boleh Dikosongkan Jika Tidak Punya Parent Unit)</label>
              <div class="autocomplete">
                <input type="text"
                       class="form-control"
                       :disabled="tipe == 'U' || tipe == 'u'"
                       @click="toggleVisibleUnit()"
                       @blur="toggleCloseVisibleUnit()"
                       v-model="queryUnit"
                       v-text="selectedItemUnit ? selectedItemUnit['text'] : ''"
                       @keydown.up="upUnit"
                       @keydown.down="downUnit"
                       @keydown.enter="selectItemUnit"
                       placeholder="Pilih Parent Unit"
                >
                <div class="popovers" v-show="visibleUnit">
                  <div class="options" v-if="matchesUnit.length != 0 && queryUnit.length != 0" ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in matchesUnit"
                          :key="index"
                          :class="{ 'selected': (selectedUnit == index)}"
                          @click="itemClickedUnit(index)"
                          v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length != 0">
                    Data Tidak Ditemukan
                  </div>
                  <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length == 0">
                    Start Typing...
                  </div>
                </div>
              </div>
            </CCol>
            <CCol sm="6">
              <label>Kode Unit</label>
              <input
                  class="form-control"
                  v-model="kodeUnit"
                  placeholder="Kode Unit"
                  type="text"
                  maxlength="10"
              />
            </CCol>
            <CCol sm="6">
              <label>Level Unit</label>
              <input
                  class="form-control"
                  v-model.trim="$v.unitLevel.$model"
                  :class="{ 'is-invalid':$v.unitLevel.$error, 'is-valid': !$v.unitLevel.$invalid }"
                  placeholder="Unit Level"
                  type="text"
              />
            </CCol>
          </CRow>
        </CCol>
      </CRow>
      <CRow class="area-button-submit">
        <CCol sm="12">
          <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
          <CButton v-if="tipe != 'C'" @click="goDelete()" class="btn btn-edit-delete mr-2">
            <span>Delete</span>
          </CButton>
          <CButton @click="submitForm()" class="btn btn-edit-submit">
            <span v-if="loading == false">Submit</span>
            <CSpinner v-else color="default" size="sm"/>
          </CButton>
        </CCol>
      </CRow>
    </div>
  </div>
</template>

<script>
import Tables from '../../../component/tablesUnit'
import {DataApi} from "../../../service/DataApi";
import {required} from 'vuelidate/lib/validators'
import {validationMixin} from 'vuelidate'
import {ModelSelect} from 'vue-search-select'

export default {
  components: {
    Tables,
    ModelSelect
  },
  mixins: [validationMixin],
  validations: {
    unitName: {
      required,
    },
    unitLevel: {
      required
    },
  },
  data() {
    return {
      success: true,
      itemHeight: 39,
      deleteModal: false,

      // data autocomplete pegawai
      dataPegawai: [],
      titlePegawai: "Pilih Pegawai",
      selectedItemPegawai: null,
      selectedPegawai: 0,
      queryPegawai: '',
      visiblePegawai: false,
      idPegawaiAtasan: '',

      // data search select Unit
      dataUnit: [],
      titleUnit: "Pilih Unit",
      selectedItemUnit: null,
      selectedUnit: 0,
      queryUnit: '',
      visibleUnit: false,
      idUnit: '',

      refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
      downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
      moreIcon: require('../../../assets/menu/icon_more.svg'),
      backIcon: require('../../../assets/menu/icon_goback.svg'),
      dataTh: ['Unit ID', 'Kode Unit', 'Nama Unit', 'Nama Atasan', 'Nama Parent Unit', 'Action'],
      dataTd: ['id', 'kodeUnit', 'bidang', 'namaPegawaiAtasan', 'parentBidang', 'action'],
      styleTable: ['150px', '200px', '300px', '200px', '300px', '100px'],
      classReload: 'reloadOff',
      goArea: true,
      loading: false,
      alertMess: '',
      currentAlertCounter: 0,

      // data model
      unitName: '',
      unitLevel: '',
      kodeUnit: '',
      tipe: 'C',
      ids: '',

      // paging
      page: 1,
      size: 20,
      totalRow: 0,
      totalPage: 1,
      firstPage: 0,
      lastPage: 0,

      // filter
      searchUnitName: '',
      searchParentUnitName: '',

      // datas
      datas: [],

      // error
      errorMessage: '',
      flagSearch: false
    }
  },
  computed: {
    matchesUnit() {
      if (this.queryUnit == '') {
        return [];
      }
      return this.dataUnit.filter((item) => item['text'].toLowerCase().includes(this.queryUnit.toLowerCase()))
    },
    matchesPegawai() {
      if (this.queryPegawai == '') {
        return [];
      }
      return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
    },
  },
  watch: {
    page() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    searchUnitName() {
      this.flagSearch = true
    },
    searchParentUnitName() {
      this.flagSearch = true
    },
    goArea() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    queryUnit() {
      if (this.queryUnit == '') {
        this.idUnit = ''
      }
      this.getDataUnit('null')
    },

    queryPegawai() {
      if (this.queryPegawai == '') {
        this.idPegawaiAtasan = ''
      }
      this.getDataPegawai('null')
    },
  },
  methods: {
    /**
     * SEARCH SELECT UNIT
     */
    getDataUnit(val) {
      let payload = ''
      if (val == 'null') {
        payload = {
          limit: 10,
          namaUnit: this.queryUnit,
          pageIn: 1,
          namaParentUnit: '',
          idUnit: ''
        }
      } else {
        payload = {
          limit: 10,
          namaUnit: '',
          pageIn: 1,
          namaParentUnit: '',
          idUnit: val
        }
      }
      DataApi.post("unit/get", payload)
          .then(res => {
            this.dataUnit = []
            let response = res.data
            let tempData = response.data.data
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = {
                value: tempData[i].id,
                text: tempData[i].bidang
              }
              this.dataUnit.push(onPush)
            }

            if (val != 'null') {
              this.queryUnit = this.dataUnit[0].text
              this.idUnit = val
            }
          })
    },

    toggleVisibleUnit() {
      this.visibleUnit = true;
    },
    hideUnit() {
      this.visibleUnit = false;
    },
    toggleCloseVisibleUnit() {
      setTimeout(this.hideUnit, 1000);
    },
    itemClickedUnit(index) {
      this.selectedUnit = index;
      this.selectItemUnit();
    },
    selectItemUnit() {
      if (!this.matchesUnit.length) {
        return;
      }
      this.selectedItemUnit = this.matchesUnit[this.selectedUnit];
      this.visibleUnit = false;
      this.queryUnit = this.selectedItemUnit.text
      this.idUnit = this.selectedItemUnit.value
      if (this.shouldReset) {
        this.queryUnit = '';
        this.selectedUnit = 0;
      }
    },
    upUnit() {
      if (this.selectedUnit == 0) {
        return;
      }
      this.selectedUnit -= 1;
      this.scrollToItemUnit();
    },
    downUnit() {
      if (this.selectedUnit >= this.matchesUnit.length - 1) {
        return;
      }
      this.selectedUnit += 1;
      this.scrollToItemUnit();
    },
    scrollToItemUnit() {
      this.$refs.optionsList.scrollTop = this.selectedUnit * this.itemHeight;
    },

    /**
     * GET DATA
     */
    sorting(value) {
      if (value == 0) {
        function compare(a, b) {
          if (a.id.toLowerCase() < b.id.toLowerCase()) {
            return -1
          }
          if (a.id.toLowerCase() > b.id.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      } else if (value == 1) {
        function compare(a, b) {
          if (a.bidang.toLowerCase() < b.bidang.toLowerCase()) {
            return -1
          }
          if (a.bidang.toLowerCase() > b.bidang.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      } else if (value == 2) {
        function compare(a, b) {
          if (a.parentBidang.toLowerCase() < b.parentBidang.toLowerCase()) {
            return -1
          }
          if (a.parentBidang.toLowerCase() > b.parentBidang.toLowerCase()) {
            return 1
          }
          return 0
        }

        return this.datas.sort(compare)
      }
    },
    getDownload() {
      if (this.datas.length != 0) {
        let limit = this.totalRow
        let nama = this.searchUnitName
        let page = 1
        let namaParent = this.searchParentUnitName

        let payload = {
          limit: limit,
          namaUnit: nama,
          pageIn: page,
          namaParentUnit: namaParent,
          idUnit: ""
        }
        DataApi.post("/export/unit/get", payload, {responseType: 'blob'})
            .then(res => {
              let response = res.data
              // let fileName = res.headers["content-disposition"].split("filename=")[1];
              const url = URL.createObjectURL(new Blob([response], {
                type: 'application/vnd.ms-excel'
              }))
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', 'Daftar Unit')
              document.body.appendChild(link)
              link.click()
            })
      }
    },
    getData() {
      if (this.flagSearch == true) {
        this.page = 1
      }
      this.$store.state.loadingScreen = true
      let limit = this.size
      let nama = this.searchUnitName
      let page = this.page
      let namaParent = this.searchParentUnitName

      let payload = {
        limit: limit,
        namaUnit: nama,
        pageIn: page,
        namaParentUnit: namaParent,
        idUnit: ""
      }
      DataApi.post("unit/get", payload)
          .then(res => {
            let response = res.data
            if (response.success == true) {
              this.datas = response.data.data
              this.totalRow = response.data.totalRow
              this.firstPage = (((this.page - 1) * this.size) + 1)
              this.lastPage = (((this.page - 1) * this.size) + this.datas.length)
              this.totalPage = Math.floor(this.totalRow / this.size)
              let modAr = this.totalRow % this.size
              if (modAr != 0) {
                this.totalPage = this.totalPage + 1
              } else {
                //
              }
            } else {
              this.datas = []
              this.totalRow = 0
              this.firstPage = 0
              this.lastPage = 0
              this.totalPage = 1
              this.errorMessage = response.message
            }
            this.flagSearch = false
            this.$store.state.loadingScreen = false
          })
    },
    findData() {
      this.getData()
    },
    movePage(direction) {
      if (direction == 'prev') {
        this.page = this.page - 1
      } else {
        this.page = this.page + 1
      }
      this.getData()
    },
    validatePage(page) {
      if (page > this.totalPage) {
        this.page = this.totalPage
      }
    },
    haveIdUnit(value) {
      if (value == true) {
        this.status = true
      } else {
        this.status = false
      }
    },
    reload() {
      this.searchUnitName = ''
      this.searchParentUnitName = ''
      this.flagSearch = true
      this.getData()
      if (this.classReload == 'reloadOff') {
        this.classReload = 'reloadOn'
      } else {
        this.classReload = 'reloadOff'
      }
    },

    /**
     * ADD DATA
     */
    moving() {
      setTimeout(this.moveArea, 600);
    },
    moveArea() {
      if (this.goArea == true) {
        this.goArea = false
      } else {
        this.goArea = true
        this.unitName = ''
        this.unitLevel = ''
        this.queryUnit = ''
        this.queryPegawai = ''
        this.kodeUnit = ''
        this.idUnit = ''
        this.idPegawaiAtasan = ''
        this.tipe = 'C'
        this.getDataUnit('null')
        this.getDataPegawai('null')
        this.$v.$reset()
      }
    },
    goSave() {
      let tipe = ''
      if (this.deleteModal == true) {
        tipe = 'D'
      } else {
        tipe = this.tipe
      }
      let namaUnit = this.unitName
      let lvl = parseInt(this.unitLevel)
      let namaParentUnit = this.idUnit
      let idUnit = this.ids
      let payload = {
        namaUnit: namaUnit,
        lvl: lvl,
        idUnit: idUnit,
        kodeUnit: this.kodeUnit,
        idParentUnit: namaParentUnit,
        tipe: tipe,
        idPegawaiAtasan: this.idPegawaiAtasan
      }
      DataApi.post("unit/save", payload)
          .then(res => {
            let response = res.data
            if (response.success == true) {
              if (response.data.Data1 == 'Y') {
                this.success = true
              } else {
                this.success = false
              }
              this.alertMess = response.data.Data2
            } else {
              this.alertMess = response.message
              this.success = false
            }
            this.deleteModal = false
            this.getData()
            this.moving()
            this.loading = false
            this.currentAlertCounter = 7
          })
    },

    /**
     * EDIT DATA
     */
    editData(value) {
      let generate = this.datas[value]
      this.unitName = generate.bidang
      this.unitLevel = generate.lvl
      this.kodeUnit = generate.kodeUnit
      this.ids = generate.id
      this.getDataUnit(generate.idParent)
      this.getDataPegawai(generate.idPegawaiAtasan)
      this.tipe = 'u'
      this.moving()
    },
    goDelete() {
      this.deleteModal = true
    },
    onDelete() {
      this.goSave()
    },
    cancelDelete() {
      this.deleteModal = false
    },

    /**
     * VALIDATE DATA
     */
    submitForm() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        //
      } else {
        this.goSave()
        this.loading = true
      }
    },

    /**
     * Autocomplete Pegawai
     **/

    getDataPegawai(val) {
      let payload = ''
      if (val == 'null') {
        payload = {
          bidang: '',
          jabatan: '',
          limit: 10,
          nama: this.queryPegawai,
          pageIn: 1,
          pegawaiId: '',
          tipePegawai: ''
        }
      } else {
        payload = {
          bidang: '',
          jabatan: '',
          limit: 10,
          nama: '',
          pageIn: 1,
          pegawaiId: val,
          tipePegawai: ''
        }
      }
      DataApi.post("pegawai/get", payload)
          .then(res => {
            this.dataPegawai = []
            let response = res.data
            let tempData = response.data.data
            var i = 0;
            for (i = 0; i < tempData.length; i++) {
              let onPush = {
                value: tempData[i].idPegawai,
                text: tempData[i].nama + ' - ' + tempData[i].nik
              }
              this.dataPegawai.push(onPush)
            }

            if (val != 'null') {
              this.queryPegawai = this.dataPegawai[0].text
              this.idPegawaiAtasan = val
            }
          })
    },
    toggleVisiblePegawai() {
      this.visiblePegawai = true;
    },
    hidePegawai() {
      this.visiblePegawai = false;
    },
    toggleCloseVisiblePegawai() {
      setTimeout(this.hidePegawai, 1000);
    },
    itemClickedPegawai(index) {
      this.selectedPegawai = index;
      this.selectItemPegawai();
    },
    selectItemPegawai() {
      if (!this.matchesPegawai.length) {
        return;
      }
      this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
      this.visiblePegawai = false;
      this.queryPegawai = this.selectedItemPegawai.text
      this.idPegawaiAtasan = this.selectedItemPegawai.value
      if (this.shouldReset) {
        this.queryPegawai = '';
        this.selectedPegawai = 0;
      }
    },
    upPegawai() {
      if (this.selectedPegawai == 0) {
        return;
      }
      this.selectedPegawai -= 1;
      this.scrollToItemPegawai();
    },
    downPegawai() {
      if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
        return;
      }
      this.selectedPegawai += 1;
      this.scrollToItemPegawai();
    },
    scrollToItemPegawai() {
      this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
    },
  },
  mounted() {
    this.getDataUnit('null')
    this.getDataPegawai('null')
    this.errorMessage = 'Find Your Data'
  },
}
</script>
<style scoped>
.containers {
  background-color: white;
  border-bottom: 1px solid #e5e6e8;
}

@media screen and (min-width: 1253px) and (max-width: 1358px) {
  .inputs-form {
    float: left;
    width: 100%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}

@media screen and (min-width: 1168px) and (max-width: 1252px) {
  .inputs-form {
    float: left;
    width: 100%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}

@media screen and (min-width: 1097px) and (max-width: 1167px) {
  .inputs-form {
    float: left;
    width: 100%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}

@media screen and (min-width: 1036px) and (max-width: 1096px) {
  .inputs-form {
    float: left;
    width: 100%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}

@media screen and (min-width: 992px) and (max-width: 1035px) {
  .inputs-form {
    float: left;
    width: 100%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}

@media screen and (min-width: 1359px) {
  .inputs-form {
    float: left;
    width: 100%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}

.btn-search {
  border-radius: 4px;
  width: 100%;
  background-color: rgba(48, 107, 221, 1);
  color: white;
}

.btn-search:hover {
  border-radius: 4px;
  width: 100%;
  background-color: rgba(48, 107, 255, 1);
  color: white;
}

.btn-add {
  border-radius: 4px;
  width: 100%;
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: white;
  color: rgba(16, 16, 16, 1);
  font-weight: 500;
  font-size: 14px;
}

.btn-add:hover {
  border-radius: 4px;
  width: 100%;
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: rgba(48, 107, 221, 1);
  color: white;
}

.btn-cancel {
  border-radius: 4px;
  width: 200px;
  float: left;
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: white;
  color: rgba(16, 16, 16, 1);
  font-weight: 500;
  font-size: 14px;
}

.btn-cancel:hover {
  border-radius: 4px;
  width: 200px;
  float: left;
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: rgba(48, 107, 221, 1);
  color: white;
}

.reloadOn {
  float: left;
  cursor: pointer;
  transform: rotate(-180deg);
  transition: 300ms linear all;
}

.reloadOff {
  float: left;
  cursor: pointer;
  transform: rotate(180deg);
  transition: 300ms linear all;
}

div.search-area {
  padding-top: 12px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 6px !important;
  background-color: white;
  z-index: 1;
}

div.sticky1 {
  position: -webkit-sticky;
  position: sticky;
  top: 54px;
  padding-top: 6px;
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 12px !important;
  background-color: white;
  z-index: 1;
}

input {
  background-color: rgba(249, 250, 252, 1);
}

.area-edit {
  background-color: white;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
}

.area-back {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.area-input {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.area-input label {
  font-size: 12px;
  color: rgba(154, 154, 154, 1);
  font-weight: 600;
  margin-bottom: 12px;
}

.area-input input, .area-input .model-select, .area-input .autocomplete {
  background-color: white;
  margin-bottom: 20px;
}

.area-button-submit {
  padding-left: 20px;
  padding-bottom: 20px;
}

.btn-edit-submit {
  border-radius: 4px;
  float: left;
  width: 200px;
  background-color: rgba(48, 107, 221, 1);
  color: white;
  font-size: 14px;
}

.btn-edit-delete {
  border-radius: 4px;
  float: left;
  width: 200px;
  background-color: red;
  color: white;
  font-size: 14px;
}

.select-invalid {
  border: 1px solid #e55353 !important;
}

.select-valid {
  border: 1px solid #2eb85c !important;
}

.autocomplete {
  width: 100%;
  position: relative;
}

.input {
  cursor: text;
}

.close {
  position: absolute;
  right: 8px;
  top: 10px;
  background: none;
  border: none;
  font-size: 14px;
  color: lightgrey;
  cursor: pointer;
}

.placeholder {
  position: absolute;
  top: 7px;
  left: 16px;
  font-size: 14px;
  color: #d0d0d0;
}

.popovers {
  text-align: center;
  width: 100% !important;
  min-height: 50px;
  border: 1px solid #d8dbe0;
  position: absolute;
  top: 35px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 8px;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 3px;
  text-align: center;
  z-index: 3;
}

.popovers input {
  right: 8px;
  left: 8px;
  width: 100%;
}

.options {
  max-height: 200px;
  overflow-y: auto;
  margin-top: 5px;
}

.options ul {
  list-style-type: none;
  text-align: left;
  padding-left: 0;
}

.options ul li {
  border-bottom: 1px solid lightgrey;
  padding: 10px;
  cursor: pointer;
  background: white;
}

.options ul li:first-child {
  border-top: 1px solid lightgray;
}

.options ul li:not(.selected):hover {
  background: whitesmoke;
  color: rgba(16, 16, 16, 1);
}

.options ul li.selected {
  background: whitesmoke;
  color: rgba(16, 16, 16, 1);
}

input:disabled {
  background-color: whitesmoke;
}
</style>
